


import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { SS_VERSION } from 'core/config';
import { Observable } from 'rxjs';


@Injectable()
export class CacheBusterInterceptor implements HttpInterceptor {



    constructor(
        @Inject(SS_VERSION)
        private readonly _version: string
    ) {
    }


    readonly #bustEndpoints = [
        'assets/'
    ]

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        const isBustEndpoint = this.#bustEndpoints.some((endpoint) => request.url.includes(endpoint));

        if (!isBustEndpoint) {

            return next.handle(request);
        }

        request = request.clone({
            setParams: {
                version: this._version
            }
        })

        return next.handle(request)

    }

}
